
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const neve4081: IProductData = {
  id: "neve-4081",
  name: "Neve 4 Channel Mic Preamp unit",
  description: "The 4081 Quad Mic Preamp builds on the incredible success of the 1081 and 1081R modules and provides both robust control and legendary Neve® sound. Every function of the 4081 can be controlled directly from the front panel or by remote control using a Mac or PC with Neve Remote Control software.",
  specialOrder: true,
  images: ["/img/neve_4081_front.jpg", "/img/neve_4081_side.jpg"],
  details: [{
    label: "Description",
    markdown: `
Every function of the 4081 can be remotely controlled from a connected Mac or PC system & multiple units can be linked together to create up to 64 individual preamp channels, all controlled from a single point. This capability allows remote preamps to be placed in the live room(s), keeping mic lines short and unlocking huge potential for many modern studios, live sound venues and broadcast suites.

Each preamp is balanced using our exclusive Marinair® specification transformers.

The 1081 family uses a class A/B circuit design, and the 4081 uses four A/B designed preamplifiers to deliver efficient performance.

The 4081’s efficient class A/B designed preamplifiers provide a high gain output of up to 70dB with a detailed, fast & musical response to transients, ideal for capturing percussive instruments with perfect clarity.

The endless stepped gain encoder applies preamp gain in 5dB steps for mic and line inputs. This system ensures ultimate accuracy when applying gain to any preamp in your system, either from the front of the unit or remotely from a connected Mac, PC.

The exact gain levels displayed on the front-mounted digital readout, with independent signal presence and clip LEDs, provide an effective at-a-glance readout of settings, ideal for large tracking sessions.

The 4081 optional digital card provides premium analogue-to-digital conversion up to 192kHz for all four preamps, connecting via AES or Firewire. Also, four digital-to-analogue converters are available for monitoring, performer cue sends or patching into analogue equipment. The unit can synchronise to external equipment via AES sync or word clock connections.

With the optional rackmount kit, the 4081 can be housed in a 2u  19″ frame, ready to mount into your studio rack. Additionally, two 4081 units can connect to form eight channels of 2U 19″ rack-mounted 1081 preamps.

The unit powers up with identical settings, levels, as they were at power-down. Phantom power, -20dB pad, and phase invert can be accessed from the front panel or controlled entirely by remote control software.

Four balanced inert points are included to expand the analogue processing capabilities of the 4081, allowing EQ’s and compressors to be inserted into the preamp signal chain before the A/D conversion stage.
`
    }, {
      label: "Specifications",
      markdown: `
• Remote control of legendary Neve® microphone preamp design
• Four genuine 1081 Mic preamp channels in a single 9.5” wide unit
• Two units can be linked together to provide 8-channels in a 19” unit with optional 19″ rack-mount kit
• Remote control using a Mac or PC with Neve Remote Control software
• XLR Mic input can be switched between Mic and electronically balanced Line
• Switchable 48V Phantom power supply
• Digital I/O Option: Firewire/AES interface with four channels of A/D conversion to either AES or FireWire and 4 channels of D/A conversion.
• Analogue Insert (pre-A/D converter) per channel
• External PSU: 100 – 240V AC, Rated Frequency 50 – 60 Hz, Rated Current 1.9A Max
• Internal Fuse: 48V DC, Fuse rating / type 1A (20mm x 5mm), Location FS1

`
}, {
  label: "Audio Performance",
  markdown: `
• Mic Input XLR input, Z in 1Kohm @ 1kHz
• Gain +20 dB to +70 dB in 5dB steps
• Maximum mic input level (with Pad):+24dB
• Outputs Max: +26dB into 600 ohms,Z out 50 ohms +/-5% @ 1kHz, balanced
• Distortion: <0.07% for 20dBm output from 50Hz to 10kHz @ 60dB Gain
• Equivalent Input Noise: >-123dBm 20Hz to 20kHz @60dB Gain
• Line Input Z in 50k ohm, unity gain, electronically balanced
`
  }, {
    label: "Dimensions",
    markdown: `
• Width: 218mm (8.5 inches)
• Height: 88.2mm (3.5 inches)
• Depth: 267 (10.5 inches)
• Weight: 3.16Kg (7 pounds)
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.ams-neve.com/outboard/microphone-preamplifiers/4081-2/" target="_blank">https://www.ams-neve.com/outboard/microphone-preamplifiers/4081-2/</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.MICPRE, HASHTAGS.RECORDING, HASHTAGS.LIVE_SOUND, HASHTAGS.TWO_U, HASHTAGS.RACK],
    manufacturer: BRAND.NEVE,
  },
  videos: []
}